import AccountApiProxyService from '@/services/AccountApiProxyService';

const GRAPHQL_PATH = '/pro/graphql';

export default {
  getProductsInfo(productSkus) {
    return AccountApiProxyService.post(GRAPHQL_PATH, {
      query: `
        query GetProductsInfo($productSkus: [String!]) {
          getProducts(productSkus: $productSkus) {
            productName
            sku
            subscribable
            productLevel
          }
        }
      `,
      variables: { productSkus },
    });
  },
  getDefaultPrice(productSku) {
    return AccountApiProxyService.post(GRAPHQL_PATH, {
      query: `
        query GetDefaultPrice($productSkus: [String!]) {
          getProducts(productSkus: $productSkus) {
            sku
            defaultPrices {
              chargePlanId
              country {
                code
              }
              currency {
                code
              }
              defaultPrice
              rateId
            }
          }
        }
      `,
      variables: { productSkus: [productSku] },
    });
  },
};
